import { Component, Input } from '@angular/core';

@Component({
    selector: 'estimate-notice',
    templateUrl: './estimate-notice.component.html',
    styleUrls: ['../../scss/styles.scss'],
    styles: [
        `
            .estimate-notice-wrap {
                padding-top: 1rem;
            }
            .estimate-notice {
                border-left: 3px solid var(--primary);
                background: #e6f2fb;
                border-radius: 0 8px 8px 0;
                padding: 14px 20px;
            }
        `,
    ],
    standalone: false,
})
export class EstimateNoticeComponent {
    @Input() message?: string;
}
